import GameInfoSection from "./GameInfoSection";
import { NavLink } from "react-router-dom";

function TeamPlayerStatsTable({
 game,
 stats,
 statValues,
 editMode,
 activePlayerId,
 setActivePlayerId,
 handleInputChange,
 finalScoreForm,
 getStatId,
 allowFGMInput,
 allowFGAInput,
 playerRegistrations = {},
}) {

 const renderStatValue = (player, stat) => {
  if (stat.abbreviation === "FGM") {
   const twoPMId = getStatId("2PM");
   const threePMId = getStatId("3PM");
   const has2P = !!twoPMId;
   const has3P = !!threePMId;

   if (has2P || has3P) {
    const twoPM = has2P ? statValues[`${player.roster_id}-${twoPMId}`] || 0 : 0;
    const threePM = has3P ? statValues[`${player.roster_id}-${threePMId}`] || 0 : 0;
    return twoPM + threePM;
   }

   return statValues[`${player.roster_id}-${stat.id}`] || 0;
  }

  if (stat.abbreviation === "FGA") {
   const twoPAId = getStatId("2PA");
   const threePAId = getStatId("3PA");
   const has2PA = !!twoPAId;
   const has3PA = !!threePAId;

   if (has2PA || has3PA) {
    const twoPA = has2PA ? statValues[`${player.roster_id}-${twoPAId}`] || 0 : 0;
    const threePA = has3PA ? statValues[`${player.roster_id}-${threePAId}`] || 0 : 0;
    return twoPA + threePA;
   }

   return statValues[`${player.roster_id}-${stat.id}`] || 0;
  }

  if (stat.abbreviation === "FG%") {
   const twoPM = statValues[`${player.roster_id}-${getStatId("2PM")}`] || 0;
   const threePM = statValues[`${player.roster_id}-${getStatId("3PM")}`] || 0;
   const twoPA = statValues[`${player.roster_id}-${getStatId("2PA")}`] || 0;
   const threePA = statValues[`${player.roster_id}-${getStatId("3PA")}`] || 0;

   const fgm = twoPM + threePM;
   const fga = twoPA + threePA;

   return fga ? ((fgm / fga) * 100).toFixed(1) + "%" : "0.0%";
  }

  if (stat.abbreviation === "FT%") {
   const ftm = statValues[`${player.roster_id}-${getStatId("FTM")}`] || 0;
   const fta = statValues[`${player.roster_id}-${getStatId("FTA")}`] || 0;
   return fta ? ((ftm / fta) * 100).toFixed(1) + "%" : 0;
  }

  if (stat.abbreviation === "2P%") {
   const made = statValues[`${player.roster_id}-${getStatId("2PM")}`] || 0;
   const attempted = statValues[`${player.roster_id}-${getStatId("2PA")}`] || 0;
   return attempted ? ((made / attempted) * 100).toFixed(1) + "%" : 0;
  }

  if (stat.abbreviation === "3P%") {
   const made = statValues[`${player.roster_id}-${getStatId("3PM")}`] || 0;
   const attempted = statValues[`${player.roster_id}-${getStatId("3PA")}`] || 0;
   return attempted ? ((made / attempted) * 100).toFixed(1) + "%" : 0;
  }

  return statValues[`${player.roster_id}-${stat.id}`] || 0;
 };

 const renderTotalCell = (teamPlayers, stat) => {
   teamPlayers = teamPlayers.filter(
     (player) => playerRegistrations[player.id] !== false
   );
  let validPercents = 0;

  let total = teamPlayers.reduce((sum, player) => {
   if (["FG%", "2P%", "3P%"].includes(stat.abbreviation)) {
    if (stat.abbreviation === "FG%") {
     return sum;
    }

    const get = (abbr) =>
     statValues[`${player.roster_id}-${getStatId(abbr)}`] || 0;

    let percent = null;

    if (stat.abbreviation === "2P%") {
     percent = get("2PA") ? (get("2PM") / get("2PA")) * 100 : null;
    } else if (stat.abbreviation === "3P%") {
     percent = get("3PA") ? (get("3PM") / get("3PA")) * 100 : null;
    }

    if (percent !== null) {
     validPercents++;
     return sum + percent;
    }

    return sum;
   }

   const val =
    stat.abbreviation === "FGM"
     ? (statValues[`${player.roster_id}-${getStatId("2PM")}`] || 0) +
     (statValues[`${player.roster_id}-${getStatId("3PM")}`] || 0)
     : stat.abbreviation === "FGA"
      ? (statValues[`${player.roster_id}-${getStatId("2PA")}`] || 0) +
      (statValues[`${player.roster_id}-${getStatId("3PA")}`] || 0)
      : statValues[`${player.roster_id}-${stat.id}`] || 0;

   return sum + val;
  }, 0);

  if (stat.abbreviation === "FG%") {
   const totalFGM = teamPlayers.reduce((sum, player) => {
    const twoPM = statValues[`${player.roster_id}-${getStatId("2PM")}`] || 0;
    const threePM = statValues[`${player.roster_id}-${getStatId("3PM")}`] || 0;
    return sum + twoPM + threePM;
   }, 0);

   const totalFGA = teamPlayers.reduce((sum, player) => {
    const twoPA = statValues[`${player.roster_id}-${getStatId("2PA")}`] || 0;
    const threePA = statValues[`${player.roster_id}-${getStatId("3PA")}`] || 0;
    return sum + twoPA + threePA;
   }, 0);

   const fgPercent = totalFGA ? (totalFGM / totalFGA) * 100 : 0;

   return <strong>{fgPercent.toFixed(1)}%</strong>;
  }

  return (
   <strong>
    {["2P%", "3P%"].includes(stat.abbreviation)
     ? validPercents > 0
      ? (total / validPercents).toFixed(1) + "%"
      : "0"
     : total}
   </strong>
  );
 };

 const renderTeamTable = ({ teamType, teamLabel, teamName, players, score }) => {
  return (
   <div className={`team-container-${teamType}`}>
    {teamType === "home" }

    <h3 className="team-header">
     {teamLabel}: {teamName || "Unknown Team"} ({score})
    </h3>

    <table className="gameAuth-stat-table">
     <thead>
      <tr>
       <th className="player-column">Player</th>
       {stats.map((stat) => (
        <th key={stat.id} className="stat-column">
         {stat.abbreviation}
        </th>
       ))}
      </tr>
     </thead>

     <tbody>
      {players.map((player) => (
       <tr
        key={player.roster_id || player.id}
        className={activePlayerId === player.id ? "active-row" : ""}
       >

          <td className="player-name">
            <span
              style={{
                color: playerRegistrations[player.id] === false
                  ? "#dc2626"
                  : "inherit",
                fontWeight: playerRegistrations[player.id] === false
                  ? "700"
                  : "inherit",
              }}
            >
              {!editMode ? (
                <NavLink
                  to={`/dashboard/players/${player.id}`}
                  style={{
                    color: "inherit",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                >
                  {player.firstName} {player.lastName}
                </NavLink>
              ) : (
                <>{player.firstName} {player.lastName}</>
              )}
            </span>

            {playerRegistrations[player.id] === false && (
              <small style={{ color: "#dc2626", marginLeft: "6px" }}>
                (Unregistered)
              </small>
            )}
          </td>


          {stats.map((stat) => (
            <td
              key={stat.id}
              style={{
                color:
                  playerRegistrations[player.id] === false
                    ? "#dc2626"
                    : "inherit",
                fontWeight:
                  playerRegistrations[player.id] === false
                    ? "700"
                    : "inherit",
              }}
            >
          {!editMode ||
           (stat.abbreviation === "FGM" && !allowFGMInput) ||
           (stat.abbreviation === "FGA" && !allowFGAInput) ||
           ["FG%", "FT%", "2P%", "3P%"].includes(stat.abbreviation) ? (
           <span className="stat-value">
            {renderStatValue(player, stat)}
           </span>
          ) : (
           <input
            type="number"
            className="stat-input"
            value={statValues[`${player.roster_id}-${stat.id}`] ?? ""}
            onFocus={() => setActivePlayerId(player.id)}
            onChange={(e) =>
             handleInputChange(
              player.roster_id,
              stat.id,
              e.target.value === ""
               ? ""
               : parseInt(e.target.value, 10)
             )
            }
           />
          )}
         </td>
        ))}
       </tr>
      ))}

      <tr className="total-row">
       <td className="player-name">
        <strong>Total</strong>
       </td>

       {stats.map((stat) => (
        <td key={stat.id}>{renderTotalCell(players, stat)}</td>
       ))}
      </tr>
     </tbody>
    </table>
   </div>
  );
 };

 return (
  <>
   {renderTeamTable({
    teamType: "home",
    teamLabel: "Home Team",
    teamName: game?.home_team?.team?.name,
    players: game?.homeTeam?.players || [],
    score: finalScoreForm.score_home,
   })}

   {renderTeamTable({
    teamType: "away",
    teamLabel: "Away Team",
    teamName: game?.away_team?.team?.name,
    players: game?.awayTeam?.players || [],
    score: finalScoreForm.score_away,
   })}
  </>
 );
}

export default TeamPlayerStatsTable;